const moduleOrder = [
  'dashboard',
  'aduan',
  'config'
]
export default moduleOrder



// WEBPACK FOOTER //
// ./src/modules/_order.js